import { EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { HttpFilter } from 'sol-request-angular/dist/comunicacao';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';
import { Filter } from 'sol-request-angular/dist/comunicacao/filter/interfaces/Filter';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';

export class TalonarioAitSearch{
    cdTalao: number;
    nrTalao: number;
    dtEntrega: Date;
    nrInicial: number;
    nrFinal: number;
    nrDaSerie: number;
    stTalao: number;
    cdAgente: number;
    dtDevolucao: Date;
    stLogin: number;
    nrUltimoAit: number;
    nmAgente: string;
    tpTalao: number;

    readonly filter: EventEmitter<HttpFilter> = new EventEmitter<HttpFilter>();
 
    constructor(data:{
        cdTalao?: number,
        nrTalao?: number,
        dtEntrega?: Date,
        nrInicial?: number,
        nrDaSerie?: number,
        nrFinal?: number,
        stTalao?: number,
        cdAgente?: number,
        dtDevolucao?: Date,
        stLogin?: number,
        nrUltimoAit?: number,
        nmAgente?: string,
        tpTalao?: number,
        })
            {
            this.cdTalao = data && data.cdTalao;
            this.nrTalao = data && data.nrTalao;
            this.dtEntrega = data && data.dtEntrega;
            this.nrInicial = data && data.nrInicial;
            this.nrFinal = data && data.nrFinal;
            this.nrDaSerie = data && data.nrDaSerie;
            this.stTalao = data && data.stTalao;
            this.cdAgente = data && data.cdAgente;
            this.dtDevolucao = data && data.dtDevolucao;
            this.stLogin = data && data.stLogin;
            this.nrUltimoAit = data && data.nrUltimoAit;
            this.nmAgente = data && data.nmAgente;
            this.tpTalao = data && data.tpTalao;
            }

    getFilters():IFilter{
        let arrayParams: Filter[] = [];

        if(this.cdTalao){
            arrayParams.push(new Equal('cdTalao', this.cdTalao));
        }
        
        if(this.tpTalao > -1 && this.tpTalao != null) {
            arrayParams.push(new Equal('tipo', this.tpTalao));
        }
        
        if(this.nrTalao){
            arrayParams.push(new Equal('talao', this.nrTalao));
        }
        if(this.dtEntrega){
            arrayParams.push(new Equal( 'dtEntrega', moment( this.dtEntrega ).format( 'DD/MM/YYYY' ) ));
        }
        
        if(this.nrInicial){
            arrayParams.push(new Equal('nrInicial', this.nrInicial));
        }
        if(this.nrFinal){
            arrayParams.push(new Equal('nrFinal', this.nrFinal));
        }

        if(this.nrDaSerie){
            arrayParams.push(new Equal('numDaSerie', this.nrDaSerie));
        }
        
        if(this.cdAgente){
            arrayParams.push(new Equal('agente', this.cdAgente));
        }
        
        if(this.dtDevolucao){
            arrayParams.push(new Equal( 'dtDevolucao', moment( this.dtDevolucao ).format( 'DD/MM/YYYY' ) ));
        }
        
        if(this.stLogin){
            arrayParams.push(new Equal('stLogin', this.stLogin));
        }

        if(this.stTalao > -1 && this.stTalao != null){
            arrayParams.push(new Equal('situacao', this.stTalao));
        }
        
        if(this.nrUltimoAit){
            arrayParams.push(new Equal('nrUltimoAit', this.nrUltimoAit));
        }

        const httpFilter: HttpFilter = new HttpFilter(arrayParams);

        return httpFilter;
    }
}
